// انتخاب مراجعه‌کننده دیگر همین مستأجر (ولی، همراه، پرداخت‌کننده، رکورد ادغام) با جستجوی زنده (AP-PAT-02).
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import type { PatientSearchItem } from '@phoenix/api-client';
import { useTranslation } from '@phoenix/i18n';
import { useState } from 'react';
import { PatientResultSummary, usePatientSearch } from './PatientSearchPalette';

export interface PatientPickerProps {
  labelKey: string;
  value: PatientSearchItem | null;
  onChange: (value: PatientSearchItem | null) => void;
  /** شناسه‌هایی که نباید پیشنهاد شوند (خود مراجعه‌کننده). */
  excludeIds?: readonly string[];
  error?: string;
  required?: boolean;
  testId?: string;
}

export function PatientPicker({ labelKey, value, onChange, excludeIds = [], error, required = false, testId }: PatientPickerProps) {
  const { t } = useTranslation('pat');
  const [text, setText] = useState('');
  const search = usePatientSearch(text, 10);
  const options = (search.data?.items ?? []).filter((item) => !excludeIds.includes(item.id));
  return (
    <Autocomplete<PatientSearchItem>
      value={value}
      onChange={(_event, next) => onChange(next)}
      inputValue={text}
      onInputChange={(_event, next) => setText(next)}
      options={options}
      filterOptions={(items) => items}
      getOptionLabel={(option) => option.displayName}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      loading={search.isFetching}
      noOptionsText={t(text.trim() ? 'pat:search.empty' : 'pat:picker.type_to_search')}
      renderOption={(props, option) => {
        const { key, ...rest } = props as typeof props & { key: string };
        return (
          <li key={key} {...rest} data-testid="patient-picker-option">
            <div>
              <div>{option.displayName}</div>
              <small>
                <PatientResultSummary item={option} />
              </small>
            </div>
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t(labelKey)}
          required={required}
          error={Boolean(error)}
          helperText={error ? t(error) : undefined}
          slotProps={{ htmlInput: { ...params.inputProps, 'data-testid': testId } }}
        />
      )}
    />
  );
}
